/* eslint-disable */
import { Box } from '@mui/material';
import { useDataContext } from '../context';
import React, { useEffect, useState } from 'react';
import { Flex, Progress, Spin } from 'antd';

const contentStyle = {
  padding: 50,
  background: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 10,
};

const content = <div style={contentStyle} />;
function AllDepartment() {
  const { data, setData } = useDataContext();
  const [dotCount, setDotCount] = useState(0);
useEffect(() => {
  const interval = setInterval(() => {
    setDotCount((prev) => (prev + 1) % 4);
  }, 500);
  return () => clearInterval(interval);
}, []);
const loadingText = `กำลังโหลด${'.'.repeat(dotCount)}`;



  return (
    <Box
      sx={{
        backdropFilter: 'blur(5px)',
        zIndex: data.spin ?99999:-99999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        inset: 0,
        backgroundColor: 'blur(5px)', // ปรับแสดงผลสีพื้นหลังตามต้องการ
        visibility: data.spin ? 'visible' : 'hidden', // ปรับแสดงผลตามสถานะการโหลด
      }}
    >
      <Spin
        indicator={<img style={{ animation: 'spin 2s linear infinite' }} alt="logo" src='/assets/images/logo1.png' />}
        tip={
         <Flex  style={{width:'100%',fontFamily: 'Noto Sans Thai', color: '#6d98ac'}} justify='center' align='center'  vertical>
          <div style={{ fontSize: 16 }}>{loadingText}</div>
                   <Progress strokeColor="#6d98ac" style={{fontFamily: 'Noto Sans Thai', color: '#6d98ac'}} percent={data.progress} steps={3} />
        </Flex>
        }
        size="large"
      >
        {content}
      </Spin>
    </Box>
  );
}

export default AllDepartment;
